<app-page padding="0">
  <div top-right>
    <app-button [matMenuTriggerFor]="topRightMenu" class="mb-1" color="primary" icon="more_vert"></app-button>
    <mat-menu #topRightMenu="matMenu">
      <button (click)="onDeleteAllClick()" [disabled]="!canDeleteAll()" mat-menu-item>
        <mat-icon class="text-red-700 material-symbols-outlined">delete_forever</mat-icon>
        <span class="text-red-700">Elimina tutti</span>
      </button>
    </mat-menu>
  </div>
  <div class="h-full p-0">
    <div *ngIf="datiPrelievo().length === 0 && isLoading() === false && !isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div class="gap-1" *ngIf="!selectedFile()">
          <div class="text-sm font-semibold uppercase text-700">Carica un file utilizzando l'apposito pulsante!</div>
<!--           <div class="text-sm">Nessun dato da visualizzare</div>
          <div class="text-sm text-700 font-light">Carica un file utilizzando l'apposito pulsante</div> -->
        </div>
        <div class="gap-1" *ngIf="selectedFile()">
          <div class="text-sm font-semibold uppercase text-700">File In Attesa di Caricamento!</div>
          <div class="text-sm">{{selectedFile()?.name}}</div>
          <div class="text-sm text-700 font-light">Clicca sull'apposito pulsante Trasmetti</div>
        </div>
        <div
        class="file-drop-zone"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onFileDrop($event)"
      >
        <span *ngIf="!selectedFile()">
          <app-button
            icon="upload"
            label="Carica il file"
            (click)="fileInput.click()"
            outlined
            vertical
          ></app-button>
          <input
            hidden
            (change)="onFileSelected($event)"
            #fileInput
            type="file"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          />
        </span>
        <div *ngIf="dragging" class="drag-overlay"></div>
      </div>
      <div
 
    >
      <span *ngIf="selectedFile()">
      <app-button
      icon="close"
      label="Cancella il file"
      (click)="resetForm()"
      outlined
      vertical
    ></app-button>
  </span>
</div>
      </div>
    </div>
    <div  *ngIf="isCheckingElaborazione()" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex flex-column md:flex-row align-items-center justify-content-between gap-1 lg:gap-3">
        <div *ngIf="isCheckingElaborazione()" class="flex"><span>Il file è stato trasmesso ai server di AnTeA. <br> Attendi il completamento del salvataggio sul database</span><mat-spinner style="transform: scale(0.3);bottom:35px"></mat-spinner></div>
      </div>
    </div>
    <div *ngIf="isLoading() === true" class="flex flex-column align-items-center justify-content-center h-full p-1 gap-1 lg:gap-3 text-700">
      <div class="flex gap-3">
        <div class="text-sm font-semibold text-700">{{selectedFile().name}}</div>
        <div class="text-sm text-700 font-light">Ultima Modifica: {{selectedFile().lastModified | date:'dd/MM/yyyy'}}</div>
      </div>
      <div class="flex flex-column w-10 md:w-6 lg:w-2">
        <mat-divider></mat-divider>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    </div>
    <table mat-table *ngIf="datiPrelievo().length > 0" [dataSource]="dataSource" class="h-full" aria-describedby="tabella prelievi">
      @for (column of displayedColumns; track column.name; let first=$first) {
        <ng-container [matColumnDef]="column.name" [sticky]="first === true">
          <th mat-header-cell *matHeaderCellDef mat-sort-header [ngClass]="{
              'mat-column-first': first === true,
            }" > {{column.label}}</th>
          <td mat-cell *matCellDef="let element" [ngClass]="{
              'bg-red-100': isOutOfRange(element[column.name], column.name),
              'bg-orange-100': isCloseToLimit(element[column.name], column.name),
              'mat-column-first': first === true,
            }">
            <div class="flex align-items-center justify-content-center gap-2">
              <mat-icon *ngIf="first === true && getRowClass(element)=='yellow'" class="text-orange-400 material-symbols-outlined">warning</mat-icon>
              <mat-icon *ngIf="first === true && getRowClass(element)=='red'" class="text-red-700 material-symbols-outlined">error</mat-icon>
              <div *ngIf="column.name === 'DataPrelievo' || column.name === 'DataAnalisi'">{{transform(element[column.name]) |date:'dd/MM/yyyy'}}</div>
              <div *ngIf="!(column.name === 'DataPrelievo' || column.name === 'DataAnalisi')">{{element[column.name]}}</div>
            </div>
          </td>
        </ng-container>
      }
      <ng-container matColumnDef="puntodiinteresse-second-group" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef class="border-right-1">
          <span class="flex align-items-center justify-content-center text-xs text-700 font-light">{{selectedFile().name}}</span>
        </th>
      </ng-container>
      <ng-container matColumnDef="prelievo-second-group" [sticky]="true" >
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="border-right-1">
          <span class="flex align-items-center justify-content-center text-xs uppercase text-700 font-light">Prelievo</span>
        </th>
      </ng-container>
      <ng-container matColumnDef="analisi-second-group" [sticky]="true" >
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="4" class="border-right-1">
          <span class="flex align-items-center justify-content-center text-xs uppercase text-700 font-light">Analisi</span>
        </th>
      </ng-container>
      <ng-container matColumnDef="parametri-second-group" [sticky]="true">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="columnsProps.length-7" class="border-right-1"></th>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="['puntodiinteresse-second-group', 'prelievo-second-group', 'analisi-second-group', 'parametri-second-group']; sticky: true;" class="example-second-header-row"></tr>
      <tr mat-header-row *matHeaderRowDef="columnsProps; sticky: true;"></tr>
      <tr mat-row *matRowDef="let row; columns: columnsProps;"></tr>
    </table>
  </div>
  <div footer class="text-center">
    <div class="flex justify-content-between w-full">
      <div class="md:px-2">
        <mat-paginator [hidePageSize]="isMobile()" [pageSize]="50" [pageSizeOptions]="[]" showFirstLastButtons [ngClass]="{ 'hiddenElement': datiPrelievo().length === 0 }" class="surface-50"></mat-paginator>
      </div>
      <div class="p-2">
        <app-button (click)="onSendClick()" [disabled]="!canSend()"  [fullWidth]="false"  icon="send" label="Trasmetti" raised/>
      </div>
    </div>
  </div>
</app-page>
